import actions from './saved_arrangements.actions';
import selectors from './saved_arrangements.selectors';
import slice from './saved_arrangements.slice';

export * from './saved_arrangements.types';

const module = {
  actions: { ...actions, ...slice.actions },
  selectors,
};

export { default as slice } from './saved_arrangements.slice';
export default module;
